<div class="container" #container>
    <aa-chart [dimensions]="dimensions" [title]="config.title">
        <svg:g
            aaAxis
            orientation="x"
            [dimensions]="dimensions"
            [scale]="xScale"
            [formatTick]="xFormatTick"
            [label]="config.xLabel"
        ></svg:g>
        <svg:g
            aaAxis
            orientation="y"
            [dimensions]="dimensions"
            [scale]="yScale"
            [formatTick]="yFormatTick"
            [label]="config.yLabel"
        ></svg:g>
        <svg:g
            aaListeningZone
            (mousePosition)="onMousePosition($event)"
            (hovered)="onHovered($event)"
        ></svg:g>
    </aa-chart>
</div>
